import {FunctionalComponent, h} from "preact";
import TextEffects from "../../effects/textEffects";
import {HTAction} from "../../libs/config";

const HumanTakeover: FunctionalComponent<{
  name: string;
  time: string;
  action: HTAction;
  msgID: string;
  disableEffects?: number[];
  tickCallback: () => void;
}> = ({ name, time, action, msgID, disableEffects, tickCallback }) => {
 let msg: string;
  switch (action) {
    case HTAction.HT_START:
      msg = `${name} just joined the chat.. 👋`;
      break;
    case HTAction.HT_END:
      msg = `👋 ${name} just left the chat..`;
      break;
  }

  return (
    <div className="humanTakeover chatMsg">
      <p id={`m_${msgID}`}>
        <TextEffects
          disableEffects={disableEffects}
          msgText={msg}
          tickCallback={tickCallback}
        />
      </p>
    </div>
  );
};

export default HumanTakeover;
